import React, { Component } from "react";
import { monthOptions, yearOptions } from "../config";
import FlexView from "react-flexview";
import SimpleDDL from "../../../../../modules/SimpleDDL";
import SimpleButton from "../../../../../modules/commons/SimpleButton";
import { fetchDataAsync } from "../../../../../Services/Utils";
import Api from "../../../../../Services/Api";
import { HttpStatus } from "../../../../common/Constants";
import moment from "moment";
import { mapToDDL } from "../../../../common/mapper";
import SimpleNestedTable from "../../../../../modules/SimpleNestedTable";
import * as R from "ramda";
class DailySalesReportByTL extends Component {
  constructor(props) {
    super(props);
    let currentDate = new Date();
    this.state = {
      month: monthOptions.find(
        (item) => item.value === currentDate.getMonth() + 1,
      ),
      year: yearOptions.find(
        (item) => item.value === currentDate.getFullYear(),
      ),
      teamLead: null,
      tableConfig: [],
      dataTable: [],
    };
  }

  componentDidMount() {
    this.handleSearch();
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      !R.equals(prevProps.doSearch, this.props.doSearch) &&
      this.props.doSearch
    ) {
      this.handleSearch();
    }
  }

  handleChangeSearchValue = (name, value) => {
    this.setState((prevValue) => ({
      ...prevValue,
      [name]: value,
    }));
  };

  formatDate = (days, month, year) => {
    return moment(`${days}-${month}-${year}`, "DD-MM-YYYY").format(
      "DD/MM/YYYY",
    );
  };

  constructConfig(value) {
    if (!value?.dataSalesDaily?.length) return [];

    const config = value.dataSalesDaily.map((item) => ({
      key: item.leasingName || item.paymentMethod,
      label: item.leasingName || item.paymentMethod,
      percentSP: item.leasingName ? item.dailyPercentMSCP : item.dailyPercentSP,
      ...item,
    }));
    console.log(config);
    

    // Add total row
    config.push({
      key: "total",
      label: "Total",
      dailyCash: value.totalDailyCash,
      dailyAccumulation: value.totalDailyAccumulation,
      percentSP: null,
    });

    return config;
  }

  fetchData = async () => {
    this.props.triggerLoading();
    const res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_REPORT_DTO").getLaporanJualanHarian,
      setError: this.props.setError,
      menuName: "Dashboard Kacab Keatas - Laporan Jual Harin By Team Lead",
      args: {
        kodeCabang: [this.props.search?.value],
        year: this.state.year?.value,
        month: this.state.month?.value,
        employeeIdTeamLeader: this.state.teamLead?.value,
      },
    });
    this.props.onSuccessSearch();
    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      const daysCount = Object.keys(res.data.data?.totalDailyCash || {}).length;

      this.setState((prevValue) => ({
        ...prevValue,
        tableConfig: this.constructConfig(res.data.data),
        dataTable: Array.from({ length: daysCount }, (_, i) =>
          this.formatDate(i + 1, this.state.month?.value, this.state.year?.value),
        ),
      }));
    }
    this.props.triggerLoading();
  };

  handleSearch = () => {
    this.fetchData();
  };

  render() {
    return (
      <>
        <FlexView style={{ gap: "20px", alignItems: "center" }}>
          <SimpleDDL
            isClearable
            id="select_options_month"
            box="search"
            name="month"
            containerclassname="width width-250px"
            placeholder="Bulan"
            styles={{
              menu: (provided) => ({
                ...provided,
                position: "relative",
                fontFamily:
                  "FontFirst2, Helvetica Neue, Helvetica, Arial, sans-serif",
              }),
            }}
            options={monthOptions}
            value={this.state.month}
            onChange={(value, { name }) =>
              this.handleChangeSearchValue(name, value)
            }
          />
          <SimpleDDL
            isClearable
            id="select_options_year"
            box="search"
            name="year"
            containerclassname="width width-250px"
            placeholder="Tahun"
            styles={{
              menu: (provided) => ({
                ...provided,
                position: "relative",
                fontFamily:
                  "FontFirst2, Helvetica Neue, Helvetica, Arial, sans-serif",
              }),
            }}
            options={yearOptions}
            value={this.state.year}
            onChange={(value, { name }) =>
              this.handleChangeSearchValue(name, value)
            }
          />
          <SimpleDDL
            id="select_options_team_leader"
            box="search"
            name="teamLead"
            containerclassname="width width-250px"
            placeholder="Nama TL"
            isClearable
            styles={{
              menu: (provided) => ({
                ...provided,
                position: "relative",
                fontFamily:
                  "FontFirst2, Helvetica Neue, Helvetica, Arial, sans-serif",
              }),
            }}
            options={this.props.dataTL.map((item) =>
              mapToDDL(item.salesLeadName, item.employeeId),
            )}
            value={this.state.teamLead}
            onChange={(value, { name }) =>
              this.handleChangeSearchValue(name, value)
            }
          />
          <SimpleButton
            styles={{ marginBottom: "15px" }}
            onClick={() => this.handleSearch()}
          >
            Cari
          </SimpleButton>
        </FlexView>
        <SimpleNestedTable
          data={this.state.dataTable}
          config={this.state.tableConfig}
        />
      </>
    );
  }
}

export default DailySalesReportByTL;
